export default __webpack_public_path__ + "static/media/img-slider-asaph-3.cb4d7e74.png";